import React, { FC } from 'react';
import { Switch, useTheme } from '@mui/material';
import { getDurationString } from '../../core/date';
import ChevronRightIcon from '../../common/icon/ChevronDownRight';
import { boxCss } from '../../common/style';
import { px2rem } from '../../core';
import { DayOfWeek } from './OpeningHoursSetting';

interface HourCardProps {
    day: DayOfWeek;
    display: boolean;
    setSelectedOpeningHours: (value: DayOfWeek) => void;
    handleToggleOpeningHours: (day: number, checked: boolean) => void;
}

const HourCard: FC<HourCardProps> = ({ day, display, setSelectedOpeningHours, handleToggleOpeningHours }) => {
    const theme = useTheme();

    const handleSwitch = async (_: React.ChangeEvent, checked: boolean) => {
        handleToggleOpeningHours(day.value, checked);
    };
    const onSelectOpeningHour = (value: DayOfWeek) => {
        setSelectedOpeningHours(value);
    };
    return (
        <div css={[boxCss(theme), { marginTop: 10, display: 'flex', alignItems: 'center', cursor: 'pointer' }]}>
            <div
                css={{
                    flex: '1 1 auto',
                }}
                onClick={() => onSelectOpeningHour(day)}
            >
                <div
                    css={{
                        marginBottom: 2,
                        lineHeight: px2rem(16),
                    }}
                >
                    {day.label}
                </div>
                <div
                    css={{
                        fontSize: px2rem(10),
                        lineHeight: px2rem(12),
                        color: theme.palette.primary70,
                    }}
                >
                    {day.openingHours && display ? (
                        <>
                            {day.openingHours.allDay && <span>24 hours</span>}
                            {!day.openingHours.allDay &&
                                day.openingHours.times.map(
                                    (t: { start: number; end: number }, idx: React.Key | null | undefined) => (
                                        <div key={idx}>
                                            {getDurationString(t.start)} - {getDurationString(t.end)}
                                        </div>
                                    ),
                                )}
                            {!day.openingHours.allDay && day.openingHours.times.length === 0 && 'Closed'}
                        </>
                    ) : (
                        'Closed'
                    )}
                </div>
            </div>
            <div
                css={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Switch checked={display} onChange={handleSwitch} />
                <div
                    css={{
                        fontSize: px2rem(20),
                        color: theme.palette.primary50,
                        paddingLeft: px2rem(10),
                    }}
                    onClick={() => onSelectOpeningHour(day)}
                >
                    <ChevronRightIcon />
                </div>
            </div>
        </div>
    );
};

export default HourCard;
